import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '../auth/auth.service';
import {Observable, Subscriber} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return new Observable<boolean>((subscriber: Subscriber<boolean>) => {
      if (this.auth.isLogged()) {
        // Check user roles
        if (route.component && 'isGranted' in route.component && 'matchAnyRole' in route.component) {
          const isGranted: string[] = <string[]>route.component.isGranted;
          const matchAnyRole: boolean = <boolean>route.component.matchAnyRole;

          // No roles specified => accept all
          if (isGranted.length === 0) {
            subscriber.next(true);
            return;
          }

          // Check roles
          if (matchAnyRole) {
            this.auth.hasAnyRoles(isGranted).subscribe((hasRoles: boolean) => {
              subscriber.next(hasRoles);
            });
          } else {
            this.auth.hasRoles(isGranted).subscribe((hasRoles: boolean) => {
              subscriber.next(hasRoles);
            });
          }
          return;
        }

        subscriber.next(true);
        return;
      }

      let redirectUrl = '/login';
      if (state.url.length) {
        redirectUrl += '?redirect=' + encodeURIComponent(state.url);
      }

      this.router.navigateByUrl(redirectUrl).then();

      subscriber.next(true);
      return;
    });
  }
}
